import React, { useEffect, useRef } from "react"
import { register } from 'swiper/element/bundle';

register();

export const Slider = React.forwardRef(({isPaused, ...props}, ref) => {
	const swiperRef = useRef(null);

	const { initialize } = props;

	const isAutoplay = !!props.params.autoplay;

	if (!isAutoplay) delete props.params.autoplay;

	const handleRef = (element) => {
		if (swiperRef)swiperRef.current = element;
		if (ref)ref.current = element;
	}

	useEffect(() => {
		const container = swiperRef.current;
		if (container === null)return;
		const params = {
			navigation: false,
			pagination: {
				clickable: true,
			},
			injectStyles: [
				`
					.swiper-pagination-bullet {
						border: var(--swiper-pagination-bullet-border);
					}
					.swiper-pagination {
						pointer-events: all !important;

					}
				`
			],
			...props.params,
		};

		Object.assign(container, params);
		if (initialize) {
			container.initialize()
		}

		// // listen for Swiper events using addEventListener
		// swiperElRef.current.addEventListener('progress', (e) => {
		// 	const [swiper, progress] = e.detail;
		// 	console.log(progress);
		// });

		// swiperElRef.current.addEventListener('slidechange', (e) => {
		// 	console.log('slide changed');
		// });
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [initialize]); // I don't like having the "issue" of having an empty array here. But, without it, SwiperJS throws some errors when it assumes navigation elements, even when there is no navigation.

	// const 

	// const pauseFunction = () => {
	// 	console.log('pause');
	// 	const container = swiperRef.current;
	// 	if (container === null) return;
	// 	console.log(container.swiper);
	// 	container.swiper.autoplay.pause();
	// }

	useEffect(() => {
		// ref = swiperRef;
		const container = swiperRef.current;
		if (container === null) return;
		if (!initialize) return;
		if (isPaused === true || !isAutoplay) {
			container.swiper.autoplay.stop();
		} else {
			container.swiper.autoplay.start();
		}
	},[isPaused, swiperRef, isAutoplay, initialize]);

	return (
		<div>
			<swiper-container init="false" ref={handleRef}>
				{props.children}
			</swiper-container>
		</div>
	);
});

export default Slider;